module.exports = __webpack_public_path__ + "assets/img/homeparticles.30a7b108.png";